// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1IwEB","visuallyhidden":"NzyiC","hide-text":"_2WTFD","center":"_3_gTa","noprint":"_2yOeh","subheading":"_2FI4V","subtitle":"_1DvZ7"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-subtitle/styles/feature.scss
 ** module id = 138
 ** module chunks = 2
 **/